class ToastManager {
  notify(type, message, duration = 5000) {
    const event = new CustomEvent('CUSTOM_HEADER_TOAST', {
      detail: { type, message, duration }
    });
    window.dispatchEvent(event);
  }

  success(message, duration) {
    this.notify('success', message, duration);
  }

  error(message, duration) {
    this.notify('error', message, duration);
  }

  info(message, duration) {
    this.notify('info', message, duration);
  }

  warning(message, duration) {
    this.notify('warning', message, duration);
  }
}

export const toast = new ToastManager();
